import {
  ChangeDetectorRef,
  Component,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { Delivery } from 'app/models/Vertical'

@Component({
  standalone: false,
  selector: 'app-ranking-chart',
  templateUrl: './ranking-chart.component.html',
  styleUrls: ['./ranking-chart.component.scss'],
})
export class RankingChartComponent implements OnDestroy {
  _data = []

  @Input()
  get data() {
    return this._data
  }

  set data(val) {
    this._data = val
    if (this.currentDelivery && this.config.categories) {
      this.getRankings()
    }
  }

  @Input() config: any = {}
  @Input() unit: string
  @Input() delivery: Delivery

  @Input() interactivity = false

  rankings: any[] = []

  constructor(private cdr: ChangeDetectorRef) {}

  ngOnDestroy() {
    this.cdr.detach()
  }

  // supossing this is ordered by date descending
  get currentDelivery() {
    if (this.delivery) {
      return (
        this.data && this.data.find((c) => c.delivery_id === this.delivery.id)
      )
    } else {
      return this.data && this.data[0]
    }
  }

  getRankings() {
    this.rankings = this.config.categories.map((cat) => {
      const ranking = this.currentDelivery.values.filter(
        (val) => val[this.config.categoryKey] === cat,
      )
      const colors = [...this.config.colors]
      if (cat === 'bottom') {
        ranking.reverse()
        colors.reverse()
      }
      return ranking
        .sort((a, b) => b.value - a.value)
        .map((el, index) => {
          el.rank = index + 1
          el.color = colors[index]
          return el
        })
    })
    this.cdr.detectChanges()
  }

  getSplittedData(): any[] {
    const deliveries = []
    this.config.categories.forEach((item, idx) => {
      const filtered = (this.data || []).slice().map((delivery) => {
        return {
          ...delivery,
          values: delivery.values.filter((val) => {
            return val[this.config.categoryKey] === item
          }),
        }
      })
      deliveries.push(filtered)
    })
    return deliveries
  }
}
